import request from "../utils/request";

export const getAccessInfo = () => {
  return request.get(`/main/plat/v2/access/getinfo`);
};

export const switchIdentity = (params) => {
  return request.post(`/main/plat/v1/access/switch_identity`, params);
};

export const getSubAccountList = (params = {}) => {
  return request.get(`/main/plat/v1/permissions/sub_accounts/list`, {
    params,
  });
};

export const getSubAccountDetail = (params = {}) => {
  return request.get(`/main/plat/v1/permissions/sub_accounts/detail`, {
    params,
  });
};

export const createSubAccount = (params) => {
  return request.post(`/main/plat/v1/permissions/sub_accounts/create`, params);
};

export const updateSubAccountPermissions = (params) => {
  return request.post(`/main/plat/v1/permissions/sub_accounts/update`, params);
};

export const disableSubAccount = (params) => {
  return request.post(`/main/plat/v1/permissions/sub_accounts/disable`, params);
};

export const enableSubAccount = (params) => {
  return request.post(`/main/plat/v1/permissions/sub_accounts/enable`, params);
};

export const removeSubAccount = (params) => {
  return request.post(`/main/plat/v1/permissions/sub_accounts/remove`, params);
};

export const getOperationLogs = (params = {}) => {
  return request.get(`/main/plat/v1/permissions/audit_logs/list`, {
    params,
  });
};
